<template>
  <div>
    <section class="tableContents">
      <tableOfContents></tableOfContents>
      <span class="graphics" data-aos="zoom-in-right" data-aos-duration="2000"
        ><img src="@/assets/images/graphics/graphic-1.png" alt=""
      /></span>
    </section>
  </div>
</template>

<script>
import tableOfContents from "@/components/common/tableOfContents.vue";
export default {
  components: {
    tableOfContents
  }
};
</script>
